"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var GroupBar = /** @class */ (function (_super) {
    tslib_1.__extends(GroupBar, _super);
    function GroupBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupBar.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'groupBar';
        _super.prototype.createLayers.call(this, layerProps);
    };
    GroupBar.getDefaultOptions = layer_1.default.getDefaultOptions;
    return GroupBar;
}(plot_1.default));
exports.default = GroupBar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/group-bar/index.js
// module id = 908
// module chunks = 37